import React, { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSEO } from "@/lib/seo";
import { toast } from "sonner";

const AMOUNTS = [25, 50, 100, 150, 250];

const GiftCardPage = () => {
  const { user } = useAuth();
  useSEO({ title: "Gift Cards | NoirbyAmara", description: "Give the gift of NoirbyAmara. Digital gift cards from £25." });
  const [amount, setAmount] = useState(50);
  const [custom, setCustom] = useState("");
  const [recipient, setRecipient] = useState("");
  const [busy, setBusy] = useState(false);

  const buy = async () => {
    const value = custom ? Number(custom) : amount;
    if (!value || value < 10) { toast("Choose an amount of at least £10."); return; }
    if (!user && !recipient) { toast("Enter the recipient email."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/payments/gift-card", { amount: value, recipient_email: recipient || undefined, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Could not start checkout."); setBusy(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-6 pt-16 md:pt-24 pb-24 text-center">
      <p className="overline text-gold mb-3">The Gift of NoirbyAmara</p>
      <h1 className="font-serif text-6xl md:text-7xl leading-none mb-6">A gift, considered.</h1>
      <p className="text-espresso/70 max-w-lg mx-auto mb-12">Give her the world of NoirbyAmara. Digital gift cards are delivered by email with a code to redeem at checkout.</p>
      <div className="flex flex-wrap justify-center gap-3 mb-6">
        {AMOUNTS.map((a) => (
          <button key={a} onClick={() => { setAmount(a); setCustom(""); }} data-testid={`gift-amount-${a}`}
            className={`px-6 py-4 border text-lg font-serif ${!custom && amount === a ? "bg-espresso text-cream border-espresso" : "border-espresso/25 hover:border-espresso"}`}>£{a}</button>
        ))}
      </div>
      <input type="number" value={custom} onChange={(e) => setCustom(e.target.value)} placeholder="Custom amount (£10–£1000)" data-testid="gift-custom"
        className="w-full max-w-xs mx-auto block bg-cream border border-espresso/20 px-4 py-3 text-sm text-center outline-none focus:border-espresso mb-4" />
      <input type="email" value={recipient} onChange={(e) => setRecipient(e.target.value)} placeholder="Recipient email" data-testid="gift-recipient"
        className="w-full max-w-xs mx-auto block bg-cream border border-espresso/20 px-4 py-3 text-sm text-center outline-none focus:border-espresso mb-8" />
      <button onClick={buy} disabled={busy} data-testid="gift-buy"
        className="bg-espresso text-cream px-12 py-4 text-[0.72rem] tracking-[0.22em] uppercase hover:bg-cocoa transition-colors disabled:opacity-50">
        {busy ? "Redirecting…" : "Purchase Gift Card"}
      </button>
    </div>
  );
};

export default GiftCardPage;
